// Third Party
import React from 'react';

// Utils
import { formatMessage, formatNumber } from '../../../../utils/i18n';
import { SCENARIO_UNIT } from '../../../../utils/income-stream';
import IncomeStreamScenario from '@/types/income-stream-scenario';

type Props = {
  scenario: IncomeStreamScenario;
  upperCaseDistributionType?: boolean;
  withSemicolon?: boolean;
};

const IncomeStreamScenarioInfo = ({ scenario, upperCaseDistributionType, withSemicolon }: Props) => {
  const { type, amount, frequency, distributionHarvest, unit } = scenario;

  const typeString = formatMessage(`Comparison.IncomeStream.Form.Type.${type}`);

  return (
    <div className="income-stream-scenario-info">
      {amount > 0 && (
        <div className="d-flex">
          <span className="type">
            {upperCaseDistributionType ? typeString.toUpperCase() : typeString}
            {withSemicolon && ':'}
          </span>

          <span className="amount">
            {unit === SCENARIO_UNIT.DOLLAR && formatMessage('Comparison.IncomeStream.FormattedCurrency', { capital: formatNumber(amount) })}

            {unit === SCENARIO_UNIT.PERCENT && `${amount}%`}
          </span>

          <span className="frequency">{formatMessage(`Comparison.IncomeStream.Form.Frequency.${frequency}`)}</span>
        </div>
      )}

      {distributionHarvest === 100 && <span className="harvest">{formatMessage('Comparison.IncomeStream.Form.DistributionsHarvested')}</span>}
    </div>
  );
};

export default IncomeStreamScenarioInfo;
